import { createSlice } from '@reduxjs/toolkit';

export const auth = createSlice({
    name: 'auth',
    initialState: {
        user: null,
    },
    reducers: {
        setAuthError: (state, action) => {
            state.error = action.payload;
        },
        setAuthUser: (state, action) => {
            state.user = action.payload;
        },
        clearAuth: (state) => {
            state.auth = null;
        },
    },
});

export default auth.reducer;

export const { setAuth, setAuthStatus, clearAuth, setAuthError, setAuthEmail, setAuthUser } =
    auth.actions;
